import * as React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, onCheckedChange, checked, ...props }, ref) => {
    return (
      <div className="relative inline-flex items-center">
        <input
          type="checkbox"
          ref={ref}
          checked={checked}
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          className="peer sr-only"
          {...props}
        />
        <div
          className={cn(
            'h-5 w-5 shrink-0 rounded border-2 border-primary ring-offset-background',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'peer-checked:bg-primary peer-checked:text-primary-foreground',
            'cursor-pointer flex items-center justify-center transition-colors',
            className,
          )}
          onClick={(e) => {
            // The visual box toggles on its own. When the component sits inside
            // a <label>, the label would otherwise forward this same click to
            // the hidden input as well, toggling it straight back (the box
            // looked dead; only the label text worked). Cancelling the click
            // cancels the label's activation, so each click toggles once.
            e.preventDefault();
            if (!props.disabled) {
              onCheckedChange?.(!checked);
            }
          }}
        >
          {checked && <Check className="h-3.5 w-3.5 text-primary-foreground" />}
        </div>
      </div>
    );
  },
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
